export default __webpack_public_path__ + "static/media/sced.ea136da0.png";